<template>
	<!-- 整个div都支持拖入下载 -->
	<div class="main-fn-all-body" @dragover.prevent="" @drop="drop">
		<!-- 固定的页头 在添加文件后会有额外的按钮  点击不触发上传文件  封装为组件5个页面公用并调用传入的不同的函数方法-->
		<mainFnHead
			:ext="ext"
			:isEmpty="!runner.files.length"
			@push="push"
			@clear="runner.clear()"
		></mainFnHead>
		<!-- 可拉伸的功能窗口 分为 初次进入时的页面 以及 导入文件后的功能页面 动态组件切换-->
		<component
			:is="mainFnBodyId"
			:titleH1="titleH1"
			:titleP="titleP"
			:imgSrc="imgSrc"
			:imgText="imgText"
			:files="runner.files"
			:options="runner.options"
			:outputExt="shuchuGeShi"
			:shuchuStyle="shuchuStyle"
			:isNormalStyle="isNormalStyle"
			:ext="ext"
			@push="push"
			@remove="remove"
			@openLimitBody1="openLimitBody1"
			:nowCompressedFormat="'PDF压缩'"
		></component>
	</div>
</template>

<script>
import mainFnHead from "./../../mycomponents/mainFnHead";
import mainFnBodyFirst from "../../mycomponents/mainFnBodyFirst";
import pdfConverter from "../../lib/PdfConverter";
import mainFnBodySecend from "../../mycomponents/mainFnBodySecend";
import hdapi from "../../common/hdapi";
import {watchLocal} from "../../common/utils";
import OnlineCompressLimit from "../dialogs/OnlineCompressLimit.vue";
const fs = require("fs");

export default {
	props: ["openLimitBody"],
	data() {
		return {
			runner: watchLocal("pdf-converter", new pdfConverter()),
			titleH1: "PDF " + this.$t("compress"),
			titleP: this.$t("text029"),
			imgSrc: "pic_pdf_big.png",
			imgText: "icon slt img (2).svg",
			ext: "pdf",
			shuchuStyle: "",
			shuchuGeShi: "",
			isNormalStyle: true,
		};
	},
	components: {
		mainFnHead,
		mainFnBodySecend,
		mainFnBodyFirst,
	},
	computed: {
		mainFnBodyId() {
			return this.runner.files.length ? mainFnBodySecend : mainFnBodyFirst;
		},
		isVIPlimit() {
			return this.$app.VIPlevel;
		},
	},
	watch: {
		isVIPlimit(newval, oldval) {
			if (newval && oldval == 0) {
				for (let x of this.runner.files) {
					if (x.state == 6 || x.size > 2 * 1024 * 1024) {
						if (window.store.isYsOver) {
							x.state = 1;
						} else {
							x._timeOut = setInterval(function () {
								if (window.store.isYsOver) {
									x.state = 1;
									clearInterval(x._timeOut);
								}
								console.log("还未清除");
							}, 1000);
						}
					}
				}
			}
		},
	},
	methods: {
		remove(file) {
			this.runner.remove(file);
		},
		push(e) {
			console.log(e);
			this.$app.isDrOver = false;
			this.runner.addFiles(e, true).then((res) => {
				// console.log("添加完成", res);
				if (res) {
					this.openOnlineLimit();
				}
				this.$app.isDrOver = true;
			});
		},
		async openOnlineLimit() {
			await this.$dlg.show(OnlineCompressLimit);
		},
		drop(e) {
			//拖拽上传
			console.log(e);
			let dropFiles = e.dataTransfer.files;
			// console.log(dropFiles);
			let todoList = Array.from(dropFiles);
			// console.log(todoList);
			if (dropFiles.length > 0) {
				let arr = [];
				arr = this.getAllFile(todoList);
				// console.log("arr2", arr);
				if (arr.length > 0) this.push(arr);
				else this.$toast.show(this.$t("pleaseselectpdffile"));
			}
		},
		getAllFile(arr) {
			let a = [];
			let b = arr
				.map((item) => item.path)
				.filter((x) => {
					let e = hdapi.extname(x).toLowerCase();
					if (e) {
						return hdapi.hasExt(x, this.ext);
					} else {
						console.log("该文件为文件夹");
						let b = this.getInFileFiles(x);
						a.push(b);
						console.log("b", b);
						return false;
					}
				});
			a.push(...b);
			console.log("arr1", a);
			return a;
		},
		getInFileFiles(url) {
			let files = fs.readdirSync(url);
			console.log("files", files);
			let _this = this;
			let obj = {};
			for (let file of files) {
				var Path = hdapi.join(url, file);
				if (fs.statSync(Path).isDirectory()) {
					// recurse
					let a = _this.getInFileFiles(Path);
					obj = Object.assign(obj, a);
					continue;
				}
				if (!hdapi.hasExt(Path, this.ext)) continue;
				obj[Path] = Path;
				// console.log("curpath", curPath);
				/**
				 * fs.statSync同步读取文件夹文件，如果是文件夹，在重复触发函数
				 */
			}
			obj["url"] = url;
			return obj;
		},
		openLimitBody1() {
			this.$emit("openLimitBody");
		},
	},
	created() {
		this.runner.options.compressLevel = 2;
	},
};
</script>

<style>
.main-fn-all-body {
	width: 100%;
	height: 100%;
	/* background-color: rgb(167, 80, 167); */
}
</style>
